// HolaCaribe API client. Dev points at the deployed API; override with REACT_APP_API_BASE.
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://api-dev.holacaribetravel.com';

const TOKEN_KEY = 'hc_admin_token';

const authHeaders = () => {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  } catch { return {}; }
};

async function parseError(res, fallback) {
  try {
    const body = await res.json();
    return body.detail || body.title || body.error || fallback;
  } catch { return fallback; }
}

export async function apiGet(path) {
  const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
  if (res.status === 401) { onSessionExpired(); throw new Error('Your session expired — please sign in again.'); }
  if (!res.ok) throw new Error(await parseError(res, `GET ${path} failed (${res.status})`));
  return res.json();
}

export async function apiSend(method, path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: body != null ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) { onSessionExpired(); throw new Error('Your session expired — please sign in again.'); }
  if (!res.ok) throw new Error(await parseError(res, `${method} ${path} failed (${res.status})`));
  return res.status === 204 ? null : res.json();
}

// Set by adminAuth so the client can bounce to login when a write is rejected.
let onSessionExpired = () => {};
export const setSessionExpiredHandler = (fn) => { onSessionExpired = fn; };

export async function apiUpload(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${API_BASE}/api/media`, { method: 'POST', headers: authHeaders(), body: fd });
  if (!res.ok) throw new Error(await parseError(res, `Upload failed (${res.status})`));
  return res.json(); // { fileId, url }
}
